import { useQuery } from '@tanstack/react-query'

import { getZeusOrganizations } from '@src/api'
import { DefaultApiGetZeusOrganizationsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchZeusOrganizations = (
  params: DefaultApiGetZeusOrganizationsRequest,
  enabled = true
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: enabled,
    queryFn: () => getZeusOrganizations(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ZEUS_ORGANIZATIONS, params],
  })
}
